<template>
  <div>
    <GTranslate />
    <router-view />
  </div>
</template>

<script>
import isCenterpagEnvironment from './utils/environment';
import GTranslate from './components/GTranslate.vue';

export default {
  name: 'App',
  components: {
    GTranslate,
  },
  mounted() {
    if (isCenterpagEnvironment()) {
      document.body.classList.add('theme-centerpag');
    } else {
      document.body.classList.remove('theme-centerpag');
    }
  },
  created() {
    this.updateFavicon();
  },
  methods: {
    updateFavicon() {
      const faviconPath = isCenterpagEnvironment()
        ? 'favicon-centerpag.svg'
        : 'favicon.svg';
      const link = document.getElementById('dynamic-favicon');
      link.href = `${faviconPath}`;
    },
  },
};
</script>

<style lang="scss">

@import '~@/assets/scss/main.scss';
@import '~@/scss/main.scss';

</style>
